import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './assets/lang/en.json';
import th from './assets/lang/th.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },
            th: {
                translation: th,
            }
        },
        lng: 'th', // default language
        fallbackLng: 'th',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false, // This is important for React.js
        },
    });

export default i18n; 